var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fd8606;}.cls-2{fill:#ffa64d;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-6{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.27,813.34C195.48,797.6,379.44,717,479.56,318.27a30.15,30.15,0,0,1,37.28-21.74c70.91,19.63,259,61,465.19,18.07a30.12,30.12,0,0,1,33.82,17.65c37.3,87.23,176.91,393,308.93,413.89a34,34,0,0,1,26.29,20.6c5.37,13.1,14.88,30.64,31,45.81a11.38,11.38,0,0,1-6.32,19.56L830.35,904.52a35.79,35.79,0,0,1-6.38.27L120.62,870.32a16.77,16.77,0,0,1-14.55-23.48l4.62-10.56A40.61,40.61,0,0,1,137.27,813.34Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M810.9,840.7C762.83,818.4,609.68,713,474,245.24c0,0-102.63,488.79-377.72,568.55l-8.14,83,745.51,32.56-5.87-64.68A29.35,29.35,0,0,0,810.9,840.7Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.27,813.34C195.48,797.6,379.44,717,479.56,318.27a30.15,30.15,0,0,1,37.28-21.74c70.91,19.63,259,61,465.19,18.07a30.12,30.12,0,0,1,33.82,17.65c37.3,87.23,176.91,393,308.93,413.89a34,34,0,0,1,26.29,20.6c5.37,13.1,14.88,30.64,31,45.81a11.38,11.38,0,0,1-6.32,19.56L830.35,904.52a35.79,35.79,0,0,1-6.38.27L120.62,870.32a16.77,16.77,0,0,1-14.55-23.48l4.62-10.56A40.61,40.61,0,0,1,137.27,813.34Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M810.9,840.7C762.83,818.4,609.68,713,474,245.24c0,0-102.63,488.79-377.72,568.55l-8.14,83,745.51,32.56-5.87-64.68A29.35,29.35,0,0,0,810.9,840.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M363.48,853s92.69-93.73,106.44-260"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.6,896.8s161.14-81.38,161.14-491.58c0,0-16.27,353.23,130.22,499.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M830.43,921.22,817.59,872a21.21,21.21,0,0,1,19.63-26.54c92.07-3.88,401.52-23.58,538.15-116.06l62.86,108.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M612.91,451.52s53.66,177,218.75,329.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1027.1,482.42c3.8-.13,7,2.81,9.18,5.92s3.89,6.69,6.91,9,8,2.74,10.19-.35c1.86-2.61.85-6.31-.88-9s-4.13-5-5.17-8.06,0-7.19,3.16-7.93c7.5,7.85,14,16.61,20.41,25.35l30,40.71c2.52,3.41,5.1,8,2.81,11.57-2.13,3.33-7.41,3.11-10.47.61s-4.44-6.46-5.7-10.2-2.68-7.76-5.78-10.26-8.43-2.68-10.54.69c-1.85,2.95-.39,6.93,1.92,9.53s5.39,4.48,7.49,7.25,2.94,7.08.48,9.54c-2.82,2.81-8,1.1-10.24-2.18s-2.59-7.46-3.39-11.36-2.48-8.1-6.11-9.73c-5.32-2.41-11.09,1.93-16.82,3.11-8,1.63-16.69-4.09-18.37-12-1.93-9.05,7-11.83,7.42-18.93.19-3.16-3.5-7.11-4.58-10.1A33,33,0,0,1,1027.1,482.42Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects01);
export default __webpack_public_path__ + "static/media/objects-01.2ea27c5989309618bc223612adaad5de.svg";
export { ForwardRef as ReactComponent };